import { lazy } from 'solid-js'
import { messages } from '../../pages/installed-page/installed-page-routing.messages.en.js'

/*
    TENANT-5433. The post-install page is a two-choice landing screen, so it
    runs on stripped chrome: the logo-only header (still a link home) and the
    locale/currency control, with no site nav and no footer. Hiding the nav is
    what `showHeaderMenu` already does on desktop; `showMobileMenu` does the
    same for the ≤767px hamburger, which no route could previously turn off.
*/
export default {
    component: lazy(() => import('../../pages/installed-page/installed-page.jsx')),
    path: '/installed',
    showFooter: false,
    showHeaderMenu: false,
    showMobileMenu: false,
    titleMessage: messages.titleMessage,
}
